import '../css/footer.css';

export default function Footer() {
    return (
        <div className="footer">
            <div className="container">
                <div className="row footer-row">
                    {/* Bhumihar Samaj Bangalore Section */}
                    <div className="col-lg-4 col-md-6">
                        <div className="footer-about">
                            <h2>Bhumihar Samaj Bangalore</h2>
                            <p>A community organization dedicated to cultural and social development, fostering unity and growth among members.</p>
                        </div>
                    </div>

                    {/* Useful Links Section */}
                    <div className="col-lg-4 col-md-6">
                        <div className="footer-link">
                            <h2>Useful Links</h2>
                            <a href="/about">Home</a>
                            <a href="/about">About</a>
                            <a href="/events">Events</a>
                            <a href="/contact">Contact</a>
                            
                        </div>
                    </div>

                    {/* Contact Us Section */}
                    <div className="col-lg-4 col-md-6">
                        <div className="footer-contact">
                            <h2>Contact Us</h2>
                            <a href="https://maps.app.goo.gl/HQg6gMPpAJ445cda6" target="_blank" rel="noopener noreferrer">
                                <p><i className="fa fa-map-marker-alt"></i> All Over Bangalore-Karnataka</p>
                            </a>
                            <a href="tel:+91-7385223242">
                                <p><i className="fa fa-phone"></i> +91-9731873276</p>
                            </a>
                            <a href="mailto:sanjivani.vitswd@vit.edu">
                                <p><i className="fa fa-envelope"></i> info@bmb.org.in</p>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            {/* Copyright Section */}
            <div className="container copyright">
                <div className="row">
                    <div className="col-md-12 text-center">
                        <p>&copy; <a href="#">Bhumihar Manch Bangalore</a> Developed by <a href='https://www.rcsinfo.in' style={{color:'yellow'}}>RCS Technology</a> | 2024, All Rights Reserved.</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
